if (!customElements.get('coffee-cart-hero-media')) {
  customElements.define('coffee-cart-hero-media', class extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      const button = this.querySelector('.cc-roastery-hero__playback');
      if (!video || !button || this.cleanup) return;

      const events = new AbortController();
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = motion.matches;
      let inView = false;
      const on = (target, type, listener) => target.addEventListener(type, listener, { signal: events.signal });
      const updateButton = () => {
        const label = video.paused ? 'Resume hero animation' : 'Pause hero animation';
        button.dataset.paused = String(video.paused);
        button.setAttribute('aria-label', label);
        button.title = label;
      };
      const syncPlayback = () => {
        if (userPaused || !inView || document.hidden) {
          video.pause();
        } else if (video.paused) {
          video.play().catch(updateButton);
        }
        updateButton();
      };

      video.muted = true;
      button.hidden = false;
      on(video, 'play', updateButton);
      on(video, 'pause', updateButton);
      on(button, 'click', () => {
        userPaused = !video.paused;
        syncPlayback();
      });
      on(motion, 'change', () => {
        if (motion.matches) userPaused = true;
        syncPlayback();
      });
      on(document, 'visibilitychange', syncPlayback);
      const observer = new IntersectionObserver(([entry]) => {
        inView = entry.isIntersecting;
        syncPlayback();
      });
      observer.observe(this);
      updateButton();
      this.cleanup = () => {
        observer.disconnect();
        events.abort();
        video.pause();
      };
    }

    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  });
}
